import { ILinkedPageObjectSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { ObjectControllableFeatureTranslator } from "./ObjectControllableFeatureTranslator";
import { LegacyLinkedPageObjectTranslator } from "./LegacyLinkedPageObjectTranslator";

export class TranscribeDateOfTimeBehaviorTranslator extends ObjectControllableFeatureTranslator<ILinkedPageObjectSpecifiable> {
  constructor() {
    super(
      "object-link",
      new LegacyLinkedPageObjectTranslator({
        isItemBeanEnable: b => b["@option"] === "1",
        complementBean: b => b["@option"] = "1",
      }));
  }
}
